import React from "react";
import { motion } from "framer-motion";
import { LuxuryBackground, PageHero } from "../components/shared/UIComponents";

export default function AccreditedNoticePage() {
  return (
    <div className="relative" data-testid="accredited-notice-page">
      <PageHero eyebrow="Legal" title="Accredited Investor Notice" description="Information regarding accredited investor requirements for certain platform opportunities." />
      <div className="relative">
        <LuxuryBackground />
        <article className="relative z-10 mx-auto max-w-4xl px-4 py-10 sm:px-6 sm:py-16 lg:px-8">
          <div className="rounded-3xl border border-cream-warm bg-white p-8 md:p-12 shadow-sm space-y-8 text-[#333] text-sm leading-7">

            <section>
              <p>Certain investment opportunities presented through the Imaani Capital platform may be available only to individuals or entities that qualify as accredited investors under applicable securities laws.</p>
              <p className="mt-3">Accredited investor status is defined under Rule 501 of Regulation D of the U.S. Securities Act of 1933.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">Accredited Investor Qualification</h2>
              <p>An individual may qualify as an accredited investor if they meet one or more of the following criteria:</p>
              <ul className="list-disc ml-6 mt-3 space-y-2">
                <li>Net worth exceeding $1,000,000, either individually or jointly with a spouse or partner, excluding the value of the primary residence.</li>
                <li>Individual income exceeding $200,000 in each of the two most recent years, or joint income with a spouse exceeding $300,000, with a reasonable expectation of reaching the same income level in the current year.</li>
                <li>Certain financial professionals holding specific securities licenses or certifications recognized by regulatory authorities.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">Entity Qualification</h2>
              <p>Entities may qualify as accredited investors if they meet certain financial thresholds or regulatory definitions, including:</p>
              <ul className="list-disc ml-6 mt-3 space-y-2">
                <li>Entities with assets exceeding $5,000,000</li>
                <li>Certain trusts with assets exceeding $5,000,000</li>
                <li>Family offices meeting regulatory asset thresholds</li>
                <li>Banks, insurance companies, registered investment companies, and other regulated financial institutions</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">Verification of Accredited Status</h2>
              <p>Where required by law, Imaani Capital or its partners may take reasonable steps to verify accredited investor status prior to permitting participation in certain investment opportunities.</p>
              <p className="mt-3">Verification methods may include review of financial documentation or confirmation from qualified third-party verification providers.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">Restricted Access to Opportunities</h2>
              <p>Certain investment opportunities may be restricted to accredited investors or other qualified participants in accordance with applicable securities laws and regulatory requirements.</p>
              <p className="mt-3">Not all users of the platform will be eligible to participate in all opportunities.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">No Public Offering</h2>
              <p>Opportunities presented through the Imaani Capital platform are not public offerings and may rely on exemptions from registration under federal and state securities laws.</p>
              <p className="mt-3">Such investments may involve additional risk and reduced regulatory protections compared to publicly registered securities.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">Independent Decision-Making</h2>
              <p>Participation in investment opportunities through the platform is voluntary and should be based on each participant's independent evaluation of risk, financial condition, and investment objectives.</p>
              <p className="mt-3">Users should consult professional advisors before making any investment decision.</p>
            </section>

          </div>
        </article>
      </div>
    </div>
  );
}
